import { lazy } from 'react';

export const ArticlePreviewPage = lazy(() => import('./ArticlePreviewPage'));
